import { Component } from '@theme/component';

/**
 * Autoplaying background video with a pause control (WCAG 2.2 · 2.2.2).
 *
 * Ported from components/VideoBanner.js. Two behaviours beyond play/pause:
 * playback stops when the banner scrolls out of view, and never starts at all
 * for a visitor who asked for reduced motion.
 *
 * @extends {Component}
 */
class AwhVideoBanner extends Component {
  #io = null;

  connectedCallback() {
    super.connectedCallback();
    const video = this.querySelector('video');
    if (!video) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      video.removeAttribute('autoplay');
      video.pause();
      this.#label(false);
      return;
    }

    if (typeof IntersectionObserver === 'undefined') return;
    this.#io = new IntersectionObserver(
      ([entry]) => {
        if (this.dataset.paused === 'true') return;
        if (entry.isIntersecting) video.play?.().catch(() => {});
        else video.pause();
      },
      { threshold: 0.15 }
    );
    this.#io.observe(this);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#io?.disconnect();
  }

  /** `event.target`, not `currentTarget` — component.js delegates on document. */
  toggle = () => {
    const video = this.querySelector('video');
    if (!video) return;
    const playing = !video.paused;
    if (playing) video.pause();
    else video.play?.().catch(() => {});
    this.dataset.paused = String(playing);
    this.#label(!playing);
  };

  #label(playing) {
    const btn = this.querySelector('[ref="toggle"]');
    if (!btn) return;
    const section = this.querySelector('.vbanner');
    btn.textContent = playing
      ? section?.dataset.pauseLabel || 'Pauzeer video'
      : section?.dataset.playLabel || 'Speel video af';
  }
}

if (!customElements.get('awh-videobanner-component')) {
  customElements.define('awh-videobanner-component', AwhVideoBanner);
}
